<template>
	<section class="list-carousel">
		<TnHeading
			v-if="header"
			type="h2"
			class="margin-bottom-l"
			>{{ header }}</TnHeading
		>
		<TnParagraph
			v-if="ingress"
			class="margin-bottom-l"
		>
			<template v-html="ingress"></template>
		</TnParagraph>

		<TnCarouselNuxt
			center
			:infinite-scroll="infiniteScroll"
			:initialSlide="component.content.startAt || 1"
			:initialSlideMobile="component.content.startAtMobile || 1"
		>
			<TnCarouselSlideNuxt
				v-for="(slide, index) in slides"
				:key="`slide-${index}`"
				:index="index"
			>
				<div>
					<img
						:src="slide.image.src"
						:alt="slide.image.alt"
					/>
					<TnHeading
						v-if="slide.header"
						type="h3"
						class="margin-top-s"
						>{{ slide.header }}</TnHeading
					>
					<RichText
						v-if="slide.slideText"
						:text="slide.slideText"
					/>
				</div>
			</TnCarouselSlideNuxt>
		</TnCarouselNuxt>

		<div
			v-if="bottomLink"
			class="bottom-link-container"
		>
			<LinkInline
				v-if="bottomLink"
				v-bind="bottomLink"
				class="link margin-top-l"
			/>
		</div>
	</section>
</template>

<script>
import LinkViewModel from "../../../../helpers/ViewModels/LinkViewModel.js";
import GizmoComponentMixin from "~/mixins/platform/GizmoComponentMixin.js";

export default defineNuxtComponent({
	name: "ListCarousel",

	mixins: [GizmoComponentMixin],

	data() {
		return {
			header: this.component.content.header,
			ingress: this.component.content.ingress,
		};
	},

	computed: {
		bottomLink() {
			if (this.component.content.bottomLink) {
				return LinkViewModel(this.component.content.bottomLink);
			}
		},
		slides() {
			return this.component.content.slides;
		},
		infiniteScroll() {
			return !!this.component.content.loopSlides;
		},
	},
});
</script>

<style lang="scss" scoped>
.list-carousel {
	* {
		text-align: center;
		font-family: $font-family-telenor-ui;
	}

	:deep(img) {
		display: block;
		margin: 0 auto;
		max-width: 60%;
	}
}
</style>
